import React from "react";
import classes from "./Shared.module.scss";

const phone = (props) => {
  return (
    <a className={[classes.callLink, classes[props.where]].join(' ')} href="tel: +18886903800">
      {props.addText ? [props.addText] : null} <br className={classes.cbr}/>
      {props.callText ? [props.callText] : '(888) 690-3800'}
    </a>
  );
}
export default phone;